jQuery(function($){

    var $body = $('body');
    var $mapa = $('.js-mapa');

    $mapa.each(function(){
        var $this = $(this);
        var $lugar = $this.find('.js-mapa__lugar');
        var $punto = $this.find('.js-mapa__punto');

        $lugar.on('click', function(e){
            e.stopPropagation();
            $lugar.removeClass('fw-700');
            $(this).addClass('fw-700');
        });

        $punto.on('click', function(e){
            e.stopPropagation();
            $punto.removeClass('active');
            $(this).addClass('active');
        });

        $body.on('click', function(){
            $lugar.removeClass('fw-700');
            $punto.removeClass('active');
        });
    });

});
